import { Radio, Select } from 'antd'
import React, { useLayoutEffect, useState } from 'react'
import {
  supportedLangCodes,
  supportLanguageList,
} from '../../../data/supportLanguage'

import { TextLang } from '../../../types'

const languageList = require('language-list')()
export default function SelectLang({
  textLang,
  setTextLang,
}: {
  textLang: TextLang
  setTextLang: any
}) {
  const [langCode, setLangCode] = useState(textLang)
  useLayoutEffect(() => {
    textLang !== 'IMAGE_ONLY' && setLangCode(textLang)
  }, [textLang])
  const unSupportedLangList = languageList
    .getData()
    .filter((language: any) => !supportedLangCodes.includes(language.code))
  const isSupportedLang = supportedLangCodes.indexOf(langCode as any) !== -1
  const isImageOnly = langCode === 'IMAGE_ONLY'
  const isTextLangSupportedLang = supportedLangCodes.includes(textLang as any)
  const [visibleUnSupportedLang, setVisibleUnSupportedLang] = useState(false)
  useLayoutEffect(() => {
    setVisibleUnSupportedLang(!isTextLangSupportedLang)
  }, [textLang, isTextLangSupportedLang])
  console.log({ langCode })
  return (
    <div>
      <Radio.Group
        className="select-lang-form-langContainer"
        value={isTextLangSupportedLang ? langCode : 'Others'}
        onChange={(e) => {
          if (e.target.value === 'Others') {
            setVisibleUnSupportedLang(true)
            setTextLang('aa')

            return
          }
          setTextLang(e.target.value)
          setVisibleUnSupportedLang(false)
        }}
      >
        {supportLanguageList.map(({ emoji, name, code }) => (
          <Radio
            key={code}
            className="select-lang-form-supportLangContainer"
            value={code}
          >
            <span className="select-lang-form-supportLang">
              <span>{emoji}</span>
              <span>{name}</span>
            </span>
          </Radio>
        ))}
        {visibleUnSupportedLang && (
          <Select
            className="select-lang-form-otherLangSelector"
            placeholder="Please select"
            value={
              langCode === 'IMAGE_ONLY' || isSupportedLang
                ? undefined
                : langCode
            }
            onChange={(v: string) => setTextLang(v)}
          >
            {unSupportedLangList.map(({ language, code }: any) => (
              <Select.Option key={code} value={code}>
                {language}
              </Select.Option>
            ))}
          </Select>
        )}
      </Radio.Group>
    </div>
  )
}
